import { useAuth } from 'oidc-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../../common/components/LoadingSpinner';
import { useAppDispatch } from '../../common/hooks';
import { DASHBOARD_API_TOKEN_NAME } from '../../constants';
import { ILoginRequest } from '../../models/Login/ILoginRequest';
import { setProfile, setProfilePhoto } from '../../redux/profileSlice';
import {
  getAccount,
  getMembershipCertificateData,
  getProfile,
  getProfilePhoto,
  handleErrorResponse,
  login,
} from '../../services';
import { env } from '../../env';
import { setToken } from '../../redux/ssoUserSlice';
import { IAccount } from '../../models/Account/IAccount';
import { setAccount, setMembership, setUserStatus } from '../../redux/accountSlice';
import { UserStatus } from '../../models/enums';
import { differenceInCalendarDays, isFuture, isPast, parse, parseISO } from 'date-fns';

const SignInPage = () => {
  const MEMBER_EXPIRING_DAYS = 60;

  const MEMBER_GRACE_PERIOD_DAYS = 30;

  const [isLoading, setIsLoading] = useState(false);

  // const isMock = env.REACT_APP_USE_MOCK === 'true';
  const isMock = window.name === 'true';

  const auth = isMock ? null : useAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  function onRedirect() {
    var loc = localStorage.getItem('location') as string;
    if (loc) {
      window.location.replace(loc);
    } else {
      navigate('/profile', { replace: true });
    }
    localStorage.removeItem('location');
  }

  const processUserStatus = (account: IAccount) => {
    var userStatus = UserStatus.Customer;
    const now = new Date();
    if (auth.userData?.profile.MembershipEndDate as string) {
      var membershipExpirationDate = parseISO(auth.userData?.profile.MembershipEndDate as string);
      if (isFuture(membershipExpirationDate)) {
        userStatus = UserStatus.Member;
        var diffInDays = differenceInCalendarDays(membershipExpirationDate, now);
        if (diffInDays >= 0 && diffInDays < MEMBER_EXPIRING_DAYS) {
          userStatus = UserStatus.ExpiringMember;
        }
      } else if (isPast(membershipExpirationDate)) {
        userStatus = UserStatus.ExpiredMember;
        diffInDays = differenceInCalendarDays(now, membershipExpirationDate);
        if (diffInDays >= 0 && diffInDays < MEMBER_GRACE_PERIOD_DAYS) {
          userStatus = UserStatus.GracePeriodMember;
        }
      }
    }
    dispatch(setUserStatus(userStatus));
  };

  function saveMockData() {
    sessionStorage.setItem(DASHBOARD_API_TOKEN_NAME, 'dummy token');
    getProfile('')
      .then((response: any) => {
        dispatch(setProfile(response.data));
        return getProfilePhoto('');
      })
      .then((response: any) => {
        dispatch(setProfilePhoto(response.data));
      })
      .catch((_error: any) => {
        handleErrorResponse(_error);
      })
      .finally(() => {
        onRedirect();
      });
  }

  function saveData() {
    if (auth.userData?.profile) {
      login()
        .then((response: any) => {
          sessionStorage.setItem(DASHBOARD_API_TOKEN_NAME, response?.data?.access_token);
          dispatch(setToken(sessionStorage.getItem(DASHBOARD_API_TOKEN_NAME)));
          return getProfile(auth.userData?.profile.SSOUUID as string);
        })
        .then((response: any) => {
          dispatch(setProfile(response.data));
          return getProfilePhoto(auth.userData?.profile.SSOUUID as string);
        })
        .then((response: any) => {
          dispatch(setProfilePhoto(response.data));
          setIsLoading(false);
          return getAccount(auth?.userData?.profile?.SSOUUID as string);
        })
        .then((response: any) => {
          var account = response.data as IAccount;
          processUserStatus(account);
          dispatch(setAccount(account));
          return getMembershipCertificateData(
            auth?.userData?.profile?.SSOUUID as string,
            auth?.userData?.profile?.SSOUUID as string
          );
        })
        .then((response: any) => {
          dispatch(setMembership(response.data));
        })
        .catch((_error: any) => {
          handleErrorResponse(_error);
        })
        .finally(() => {
          onRedirect();
        });
    } else {
      setIsLoading(true);
    }
  }

  useEffect(() => {
    // alert('is mock: ' + env.REACT_APP_USE_MOCK);
    if (isMock) {
      saveMockData();
    } else {
      saveData();
    }
  }, [auth?.isLoading]);

  return (
    <React.Fragment>
      <div>
        <br />
        {auth?.userData && !isLoading ? (
          <div>
            {/* <p>User data: {JSON.stringify(auth.userData.profile)}</p>
            <p>ssoUUId: {auth.userData.profile.SSOUUID}</p>
            {/* <p>user data from state: {JSON.stringify(userData)}</p> */}
            {/* <p>
              You are now logged in. Click{' '}
              <a href='#' onClick={onRedirect}>
                here
              </a>{' '}
              to access MySHRM.
            </p> */}
            {/* <p>
              Save Data. Click{' '}
              <a href='#' onClick={saveData}>
                here
              </a>{' '}
              to access MySHRM.
            </p> */}
          </div>
        ) : (
          <div>
            <LoadingSpinner />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default SignInPage;
